module.exports = __webpack_public_path__ + "img/PL08702.14be51fc.png";